import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const WaitlistPage: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [userType, setUserType] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setEmailError('');

    const waitlistData = {
      email: email,
      category: userType,
      device_type: navigator.platform || undefined,
      browser: navigator.userAgent || undefined,
      operating_system: navigator.platform || undefined
    };

    try {
      const response = await axios.post('https://api.sowphie.farm/waitlist/signup', waitlistData);
      if (response.data.status === "success") {
        setEmail('');
        setUserType('');
        alert('Successfully joined waitlist!');
      }
    } catch (error: any) {
      if (error.response?.status === 400 && error.response?.data?.detail.includes("already registered")) {
        setEmailError('This email is already registered');
      } else {
        alert('Failed to join waitlist. Please try again later.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-[#EDEDE5] z-50 overflow-y-auto">
      <div className="min-h-screen py-16">
        <div className="absolute top-0 left-0 right-0 flex justify-between items-center p-6">
          <img
            src="/images/logoonly.png"
            alt="Smart Farm Logo"
            className="w-14 h-14 object-contain cursor-pointer"
            onClick={() => navigate('/home')}
          />
          <button
            onClick={() => navigate('/faq')}
            className="text-[#475802] text-lg font-semibold hover:text-green-900 hover:underline font-poppins pr-10"
          >
            FAQs
          </button>
        </div>

        <div className="max-w-md mx-auto px-4 pt-20">
          <h2 className="text-2xl font-semibold text-center text-black mb-10 font-sedan">
            Want To Get Notified When We Launch?
          </h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-lg font-semibold text-gray-700 mb-1">
                Farmer or Partner:
              </label>
              <select
                value={userType}
                onChange={(e) => setUserType(e.target.value)}
                className="w-full px-6 py-2 border border-[#91A93D] rounded-full focus:border-[#475802] focus:ring-2 focus:ring-[#475802] bg-white"
                required
                disabled={isSubmitting}
              >
                <option value="">Select Your Category</option>
                <option value="farm_owner">Farm Owner</option>
                <option value="farm_manager">Farm Manager</option>
                <option value="agronomist_veterinarian">Agronomist/Veterinarian</option>
                <option value="agrovet_outlet">Agrovet Outlet</option>
                <option value="credit_insurance_provider">Credit/Insurance Provider</option>
                <option value="inputs_supplier_distributor">Inputs Supplier/Distributor</option>
              </select>
            </div>

            <div>
              <label className="block text-md font-semibold text-gray-700 mb-1">
                Email Address:
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="yourname@example.com"
                className="w-full px-6 py-2 mb-6 border border-[#91A93D] rounded-full placeholder:text-[#A8A9A7] focus:border-[#475802] focus:ring-2 focus:ring-[#475802]"
                required
                disabled={isSubmitting}
              />
              {emailError && <p className="text-red-500 mt-2">{emailError}</p>}
            </div>

            <div className="flex justify-center gap-4">
              <button
                type="submit"
                disabled={isSubmitting}
                className={`px-20 py-3 bg-[#91A93D] text-white font-semibold rounded-full shadow-md hover:bg-[#475802] transition-all duration-300 ${
                  isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                {isSubmitting ? 'Submitting...' : 'Notify Me'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WaitlistPage;